import {  loadStripe } from '@stripe/stripe-js'
import type {Stripe} from '@stripe/stripe-js';
import type {
  BillingClient,
  OpenCheckoutInput,
  OpenCheckoutResult,
} from './IBillingClient'
import { logger } from '@/lib/monitoring/logger'
import { LogCategory } from '@/lib/monitoring/types'

let stripePromise: Promise<Stripe | null> | null = null

function getStripe(publicKey: string): Promise<Stripe | null> {
  if (!stripePromise) {
    stripePromise = loadStripe(publicKey)
  }
  return stripePromise
}

export function createStripeBillingClient(publicKey: string): BillingClient {
  // Ensure Stripe.js loads early — keeps the redirect responsive when the
  // user clicks Upgrade. Failure is logged but non-fatal: the redirect
  // path uses window.location.href and doesn't actually require Stripe.js.
  void getStripe(publicKey).catch((error) => {
    logger.logError(error, LogCategory.SUBSCRIPTION, {
      message: 'Failed to preload Stripe.js',
    })
  })

  return {
    async openCheckout(input: OpenCheckoutInput): Promise<OpenCheckoutResult> {
      const url = input.sessionIdOrUrl
      if (!url || !url.startsWith('http')) {
        throw new Error('Stripe checkout URL is missing or not a full URL')
      }
      window.location.href = url
      // The page is unloading; this promise will never resolve. The caller
      // can safely await it without worrying about post-redirect logic.
      return new Promise<OpenCheckoutResult>(() => {})
    },

    openPortal(url: string): void {
      window.location.href = url
    },
  }
}
